import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions';
import template from '../../templates/PageLayout/GlobalHeaderButtons.rt';
import {AccessRights, PARTS} from '../../schemas/accessRightsModel';
import {size} from "lodash";
import {getAuthSubDomain, hardCodeIsEncore} from "../../constants/fabricatorHardcode";

function mapStateToProps(state) {
  const {auth, asCustomer} = state;
  const AR = AccessRights.get(state);

  const subDomain = getAuthSubDomain(auth, asCustomer);
  const isEncore = hardCodeIsEncore(subDomain);

  return {
    auth: auth,
    AR,
    showGlobalMarkUpButton: AR.e(PARTS.GLOBAL_MARKUP) || AR.isSiteAdmin(true),
    isEncore,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch(actions.logout()),
    go: path => dispatch(actions.changeLocation(path))
  };
}

class globalHeaderButtons extends PureComponent {
  _forceUpdate = () => this.forceUpdate();
  componentDidMount() {
    document.addEventListener('reset-set-as', this._forceUpdate);
  }
  componentWillUnmount() {
    document.removeEventListener('reset-set-as', this._forceUpdate);
  }
  render() {
    return template.apply(this);
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps);

const GlobalHeaderButtons = connector(globalHeaderButtons);

export {GlobalHeaderButtons};

